import { h } from "preact";
import { useEffect, useRef } from "preact/hooks";
import Splide from "@splidejs/splide";
import { classNames } from "../helpers";

export default function Carousel({
  buttonsOnHover,
  images,
  inLightbox,
  onSlideClick,
  start,
}) {
  const splideElem = useRef(null);
  useEffect(() => {
    new Splide(splideElem.current, {
      type: "loop",
      width: "100%",
      perPage: 1,
      autoHeight: true,
      arrows: images.length > 1,
      gap: 24,
      padding: 0,
      autoplay: false,
      pagination: !inLightbox && images.length > 1,
      start: start || 0,
    }).mount();
  }, []);

  return (
    <div class="image-carousel splide" ref={splideElem}>
      <div class="splide__track" data-splide-el="track">
        <ul class="splide__list">
          {images.map((item) => (
            <li key={item.url} class="splide__slide">
              <img
                class="image-carousel__slide__content"
                src={item.url}
                alt={item.alt}
                onClick={() => onSlideClick && onSlideClick(item)}
              />
            </li>
          ))}
        </ul>

        <div
          class={classNames(
            "splide__arrows image-carousel__arrows",
            buttonsOnHover && "image-carousel__arrows--initial-hidden"
          )}
        >
          <button class="button button--circular splide__arrow splide__arrow--prev">
            <i class="material-symbols-rounded icon t-body1">chevron_left</i>
          </button>
          <button class="button button--circular splide__arrow splide__arrow--next">
            <i class="material-symbols-rounded icon t-body1">chevron_right</i>
          </button>
        </div>
      </div>
    </div>
  );
}
